import { useMemo } from 'react';

import { colors, fontSizes } from '../../theme';
import type { DefaultComponentProps, Nullable } from '../../types';
import { DropdownOption } from '../Dropdown';
import FlatDropdown from '../FlatDropdown/FlatDropdown';
import type { FlatDropdownChangeEventHandler } from '../FlatDropdown/types';
import Flex from '../Flex';
import Typography from '../Typography';

export type FlatDropdownFieldProps = DefaultComponentProps & {
  label: string;
  selectedOption: Nullable<Pick<DropdownOption, 'value' | 'label'> | string>;
  options: DropdownOption[];
  onChange: FlatDropdownChangeEventHandler;
};

const FlatDropdownField: React.FC<FlatDropdownFieldProps> = ({
  label,
  selectedOption: selectedOptionProp,
  options,
  onChange,
  'data-testid': dataTestId,
  ...rest
}) => {
  const selectedOption = useMemo(() => {
    if (typeof selectedOptionProp !== 'string') {
      return selectedOptionProp;
    }

    return options.find(item => item.value === selectedOptionProp);
  }, [options, selectedOptionProp]);

  return (
    <Flex align="center" gap="4x" {...rest}>
      {label && (
        <Typography color={colors.pigeon} fontSize={fontSizes.m}>
          {label}:
        </Typography>
      )}
      <FlatDropdown
        data-testid={dataTestId}
        options={options}
        selectedOption={selectedOption}
        onChange={onChange}
      />
    </Flex>
  );
};

export default FlatDropdownField;
